/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    isResponsive: false,
    // options
    allEventsLink: true,
    allEventsLinkText: 'VIEW ALL EVENTS',
    hasImages: true,
    imageBackground: true,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: 'BUY NOW' },
    moreButton: { visible: true, text: 'MORE' },
    maxItemsVisible: 4,
    hasDescription: false,
    textContainer: true,
    link: 'all', // options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: 'image',
      2: 'date',
      3: 'title',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      function getDaySuffix(day) {
        const suffixes = ['th', 'st', 'nd', 'rd'];
        const digit = day % 10;

        // 11, 12 y 13 son excepciones y siempre tienen "th" como sufijo
        if (day >= 11 && day <= 13) {
          return 'th';
        }

        // Los demás números toman el sufijo correspondiente del array
        return suffixes[digit] || 'th';
      }

      function formatDate(el) {
        const datesMonth = el.text().slice(0, 3);
        const datesDay = el.text().slice(4, 7).replace(',', '');
        const daySuffix = getDaySuffix(datesDay);
        el.html(`${datesMonth} ${datesDay}<sup>${daySuffix}</sup>`);
      }

      if (data.length === 0) {
        $('.events-section').find('.container').remove();
      } else {
        const allEvents = $('.all-events-btn');
        allEvents.addClass('button');
        allEvents.appendTo($(`#${widgetName}`));

        $('#multiScheduleFeature .featureItem').each(function (i) {
          const item = $(this);
          const button = item.find('.more-button');
          button.addClass('buttonSmall');
          const eventDate = item.find('.featureItemDate');
          formatDate(eventDate);
        });
      }
    },
  });
}

// helper functions

function setCharLimit(el, limit) {
  const text = el.text();
  return text.length > limit ? `${text.substring(0, limit)}...` : text;
}
